export default "__VITE_ASSET__h16yQ9WD__"